'use strict';

/*
 * Overrides the default input to update on blur
 */

angular.module('posApp').directive('ngModelOnblur', () => ({
  restrict: 'A',
  require: 'ngModel',

  link: function (scope, elm, attr, ngModelCtrl) {
    if (attr.type === 'radio' || attr.type === 'checkbox') {
      return;
    }

    elm.unbind('input').unbind('keydown').unbind('change');
    elm.bind('blur', () => {
      scope.$apply(() => {
        ngModelCtrl.$setViewValue(elm.val());
      });
    });
  },
}));
